const isValidFile = (fileName, types) => {
  const fileType = fileName.split('.').pop();
  return types.includes(fileType?.toLowerCase());
};

const validateFileSize = (size, maxSize) => size <= maxSize;

const isValidHttpUrl = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

const validateEmail = (email) => {
  const re =
    /^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[@][a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,4}$/;
  return re.test(String(email).toLowerCase());
};

const REGEX_SPECIAL_CHARACTERS = /[^a-zA-Z0-9]/g;

const REGEX_LOWER_CASE_SPECIAL_CHARACTERS = /^[a-z0-9]+$/;

const validateLowerCaseSpecialCharacters = (string) =>
  REGEX_LOWER_CASE_SPECIAL_CHARACTERS.test(string);

const validateSpecialCharacters = (string) =>
  REGEX_SPECIAL_CHARACTERS.test(String(string));

export {
  REGEX_SPECIAL_CHARACTERS,
  isValidFile,
  validateFileSize,
  isValidHttpUrl,
  validateEmail,
  validateSpecialCharacters,
  validateLowerCaseSpecialCharacters,
};
